import { render, staticRenderFns } from "./OrcidModal.vue?vue&type=template&id=c9be11be&scoped=true"
import script from "./OrcidModal.vue?vue&type=script&lang=js"
export * from "./OrcidModal.vue?vue&type=script&lang=js"
import style0 from "./OrcidModal.vue?vue&type=style&index=0&id=c9be11be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9be11be",
  null
  
)

export default component.exports